import { useSelector } from 'react-redux';
import { getDomainsStore } from '@/store/domain/actions';
import { getValidEmailsStore } from '@/store/validemails/actions';
import { useGetDefaultSender } from '@/services/hooks/useGetDefaultSender';
import { isEmailVerified } from '@/services/tools/isEmailVerified';
import { isDomainVerified } from '@/services/tools/isDomainVerified';
import { isOwnDomain } from '@/services/tools/isOwnDomain';
import { EmailDropdownGroupEnum, EmailDropdownOption } from '../types';

export const useGetEmailsOptions = (): EmailDropdownOption[] => {
    const { emails } = useSelector(getValidEmailsStore);
    const { email: defaultEmail } = useGetDefaultSender() ?? {};
    const verifiedEmails = emails?.filter((email) => isEmailVerified(email) && email.Email !== defaultEmail);
    const emailsNames = verifiedEmails?.map((email) => email.Email);
    const { domains } = useSelector(getDomainsStore);
    const verifiedDomains = domains?.filter((domain) => isDomainVerified(domain) && isOwnDomain(domain));

    const verifiedEmailsWithDefault = [defaultEmail, ...emailsNames];

    const domainsNames = verifiedDomains?.map((domain) => domain.Domain.split(' (')[0]);
    const domainsGroup = domainsNames?.map((domain) => ({
            name: domain,
            value: `@${domain}`,
            group: EmailDropdownGroupEnum.Domains,
        })) ?? [];

    const validEmailsGroup = verifiedEmailsWithDefault?.map((email) => ({
            name: email,
            value: email,
            group: EmailDropdownGroupEnum.Emails,
        })) ?? [];

    return [...domainsGroup, ...validEmailsGroup]
};
